import { ApplicationConfig, provideZoneChangeDetection, ErrorHandler } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { appRoutes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtInterceptor } from './auth/data/jwt-interceptor.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ApiUrlInterceptor } from './shared/data/api-url.interceptor';
import { RaygunErrorHandler } from './shared/data/raygun-error-handler.service';
import { onViewTransitionCreated } from './shared/util/view-transition.util';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withViewTransitions({
      onViewTransitionCreated,
    })),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiUrlInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: RaygunErrorHandler
    }
  ],
};
